"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Operators = _styledComponents.default.div.withConfig({
  displayName: "Operators",
  componentId: "design-system__sc-1kyr2y7-0"
})(["border-left:2px dashed #cfd8dc;padding-left:1.5rem;margin-left:1rem;.operatorsHolder{padding:0.5rem 0;> div{padding:0.5rem 0;position:relative;&:first-child:before{content:\"\";display:block;width:30px;border-top:2px dashed #cfd8dc;position:absolute;left:-1.5rem;bottom:25px;}.Field{width:250px;}&.FieldValue .Field{width:300px;}}}.AddOperators{background-color:#ffffff;border:1px solid #cccccc;border-radius:4px;width:38px;height:38px;position:relative;bottom:-19px;font-size:26px;color:#299eff;cursor:pointer;}.buttonHolder{position:relative;&:before{content:\"\";display:block;width:30px;border-top:2px dashed #cfd8dc;position:absolute;left:-1.5rem;bottom:0;}}.FieldGroup{display:flex;align-items:flex-start;.Field + .Field{margin-top:0;margin-left:1rem;}}"]);

var _default = Operators;
exports.default = _default;